// extracted by mini-css-extract-plugin
export var group = "TM1FunctionDisplay-module--group--35ecd";
export var innerWrapper = "TM1FunctionDisplay-module--innerWrapper--f804c";
export var wrapper = "TM1FunctionDisplay-module--wrapper--bc85f";